/*
 * File Created: Saturday, 10th December 2022 3:51:34 pm
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2022 Addble Solutions Private Limited. All Rights Reserved.
 */
import {
  FaDiscord,
  FaFacebookF,
  FaInstagram,
  FaPinterest,
  FaTwitter,
  FaYoutube,
  FaWhatsapp,
  FaSlack,
  FaLinkedin,
} from 'react-icons/fa';
import { IconType } from 'react-icons/lib';

export const Facebook: IconType = FaFacebookF;
export const Twitter: IconType = FaTwitter;
export const Instagram: IconType = FaInstagram;
export const Youtube: IconType = FaYoutube;
export const Pinterest: IconType = FaPinterest;
export const Discord: IconType = FaDiscord;
export const Whatsapp: IconType = FaWhatsapp;
export const Slack: IconType = FaSlack;
export const LinkedIn: IconType = FaLinkedin;
